export type IssueFrontDeskKeycardPayload = {
  stayId: string;
  reservationId: string;
  roomId: string;
  guestId: string;
};

export type IssueFrontDeskKeycardResult = {
  provider: string;
  encoderReference: string;
};

export interface FrontDeskKeycardProvider {
  issueKeycard(payload: IssueFrontDeskKeycardPayload): Promise<IssueFrontDeskKeycardResult>;
}

export class InMemoryFrontDeskKeycardProvider implements FrontDeskKeycardProvider {
  readonly provider = "in-memory-keycard";
  readonly issuedPayloads: IssueFrontDeskKeycardPayload[] = [];

  async issueKeycard(payload: IssueFrontDeskKeycardPayload): Promise<IssueFrontDeskKeycardResult> {
    this.issuedPayloads.push(payload);
    return {
      provider: this.provider,
      encoderReference: `enc-${this.issuedPayloads.length.toString().padStart(4, "0")}`,
    };
  }
}

